import { PureComponent } from "react";
import querystring from "querystring";

import { overview } from "../../../../../routes";
import { logError } from "common/debug-print";
import { getAppFacilities } from "webapp/lib/app-renderer";
import { sleep, isResponseOK } from "common/Support";
import { IntegrateWithStripeBody } from "common/firebase-function-types";
import { LoadingIndicator } from "../../../orgs/orgs-styles";

function redirectToRoot() {
    window.location.assign(overview + "?stripeConnectFailed");
}

// FIXME: This all looks terrible.
export class ConnectStripeReturnScreen extends PureComponent {
    public async componentDidMount() {
        try {
            const params = querystring.parse(window.location.search.replace(/^\?/, ""));
            const { code: authorization, state: token } = params;
            // FIXME: These can also be string[], as per type definition.  Can that
            // actually occur, and if so, how do we need to handle it?
            if (typeof authorization !== "string" || typeof token !== "string") {
                logError(`Missing information to complete connect. auth=${authorization} token=${token}`);
                logError(params);
                return redirectToRoot();
            }

            const appFacilities = getAppFacilities();
            while (!(await appFacilities.isSignedInToFirebase())) {
                await sleep(500);
            }

            const body: IntegrateWithStripeBody = { authorization, token, postConnectURL: undefined };
            const integrationResponse = await appFacilities.callAuthCloudFunction("integrateWithStripe", body);
            if (!isResponseOK(integrationResponse)) {
                const reason = integrationResponse === undefined ? "Network error" : integrationResponse.statusText;
                logError(`Could not connect Stripe account: ${reason}`);
                return redirectToRoot();
            }
            const { redirectURL, closeOnSuccess } = await integrationResponse.json();
            if (redirectURL === undefined) {
                logError("Stripe connection redirect was undefined?");
                return redirectToRoot();
            }
            if (typeof closeOnSuccess === "boolean" && closeOnSuccess) {
                window.close();
            } else {
                window.location.assign(redirectURL);
            }
        } catch (e: unknown) {
            logError(`Could not connect Stripe account: ${e}`);
            logError(e);
            return redirectToRoot();
        }
    }

    public render() {
        // FIXME: This used to have a title. Bring it back.
        return <LoadingIndicator />;
    }
}
